import { useState } from "react";
import { Typography, Button, Snackbar, CircularProgress, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import InspectionSection from "./InspectionSection";
import {
  SAVE_CLIENT_EQUIPMENT_INSPECTION_FORMS,
  SAVE_CLIENT_EQUIPMENT_INSPECTION_RESPONSEPITURES,
  SAVE_CLIENT_EQUIPMENT_INSPECTION_RESPONSES
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import GeneralComponent from "./GeneralComponentStatic";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

const AddEquipmentInspections = () => {
  const { selectedClientData, loginData, multiLanguageData } = useSelector((state) => state?.main);
  const location = useLocation();
  const navigate = useNavigate();
  const { qid: item } = useParams();
  const userId = loginData?.userInformation?.UserId;
  const inspectionRecord = location?.state?.inspectionRecord || null;
  const inspectionTypeId = inspectionRecord?.inspectionTypeId || item;
  const [generalComponentData, setGeneralComponentData] = useState({});
  const [formItems, setFormItems] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [isImgChanged, setIsImgChanged] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const LANGUAGE = ClientEnglishFallback.AddEquipmentInspections(
    multiLanguageData?.AddEquipmentInspections || {}
  );
  const {
    TEXT_SNACKBAR_INVALID_MSG,
    TEXT_SNACKBAR_SUCCESS,
    TEXT_SNACKBAR_FAILED,
    TEXT_CANNOT_EDIT,
    TEXT_SUBMIT
  } = LANGUAGE;

  const validateFields = () => {
    return Object.keys(selectedAnswers).length === formItems.length;
  };

  const submitFormItems = async (formId) => {
    const isValid = validateFields();

    if (!isValid) {
      setSnackbarMessage(TEXT_SNACKBAR_INVALID_MSG);
      setSnackbarOpen(true);
      setLoading(false);
      return false;
    }

    const responses = Object.entries(selectedAnswers).map(([key, value]) => ({
      Id: 0,
      EquipmentInspectionFormId: formId,
      EquipmentInspectionItemId: key,
      Response: value,
      ModifiedBy: userId
    }));

    const payload = {
      UserId: userId,
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: responses
    };

    const response = await Postrequestcall(
      SAVE_CLIENT_EQUIPMENT_INSPECTION_RESPONSES,
      payload,
      loginData?.accessToken
    );
    if (response?.status) {
      if (Object.keys(isImgChanged).length > 0) {
        await submitFormItemsPictureResponse(response.data.data);
      }
      return true;
    } else {
      return false;
    }
  };

  const submitFormItemsPictureResponse = async (responseArray) => {
    let isSubmitted = false;

    for (const item of responseArray) {
      const itemId = item.objData.equipmentInspectionItemId;

      if (isImgChanged[itemId]) {
        for (const img of isImgChanged[itemId]) {
          const formData = new FormData();
          formData.append("Id", 0);
          formData.append("ClientId", selectedClientData?.ClientId);
          formData.append(
            "EquipmentInspectionResponseId",
            item.objData.EquipmentInspectionResponseId
          );
          formData.append("PictureName", img);
          formData.append("ModifiedBy", userId);

          const response = await Fileuploadrequestcall(
            SAVE_CLIENT_EQUIPMENT_INSPECTION_RESPONSEPITURES,
            formData,
            loginData?.accessToken
          );

          if (response?.status === true) {
            isSubmitted = true;
          } else {
            isSubmitted = false;
            break;
          }
        }
      }
    }

    return isSubmitted;
  };

  const submitInspectionForm = async () => {
    try {
      const response = await Postrequestcall(
        SAVE_CLIENT_EQUIPMENT_INSPECTION_FORMS,
        generalComponentData,
        loginData?.accessToken
      );
      return response;
    } catch (err) {
      console.error("submitInspectionForm-> Form Submission Error:", err);
      return false;
    }
  };

  const handleSubmit = async () => {
    try {
      const allAnswerGiven = Object.keys(selectedAnswers).length === formItems.length;
      if (allAnswerGiven === false) {
        setSnackbarMessage(TEXT_SNACKBAR_FAILED);
        setSnackbarOpen(true);
        return
      }
      setLoading(true);
      const isGeneralValid = true

      const result1 = isGeneralValid ? await submitInspectionForm() : false;
      // console.log("result1=======+++++++++++++++", result1?.data?.data);
      const result2 = await submitFormItems(result1?.data?.data?.[0]?.objData?.id);

      if (result1?.status || result2) {
        setSnackbarMessage(TEXT_SNACKBAR_SUCCESS);
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate(`/client/${selectedClientData?.ClientId}/equipment-inspection`);
        }, 500);
      } else {
        setSnackbarMessage(TEXT_SNACKBAR_FAILED);
        setSnackbarOpen(true);
      }
      setLoading(false);
    } catch (error) {
      console.log("handleSubmit-> Error When Submitting Inspection: ", error);
      setLoading(false);
    }
  };

  return (
    <Box>
      <GeneralComponent
        setGeneralComponentData={setGeneralComponentData}
        typeId={inspectionTypeId}
        generalComponentData={generalComponentData}
        userId={userId}
        inspectionRecord={inspectionRecord}
      />
      <InspectionSection
        inspectionData={inspectionTypeId}
        selectedAnswers={selectedAnswers}
        setSelectedAnswers={setSelectedAnswers}
        formItems={formItems}
        setFormItems={setFormItems}
        isImgChanged={isImgChanged}
        setIsImgChanged={setIsImgChanged}
      />
      <Box
        sx={{
          // p: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}>
        <Typography sx={{ mt: 2, color: "#555" }}>{TEXT_CANNOT_EDIT}</Typography>
        <Button
          variant="contained"
          color="error"
          size="medium"
          disabled={loading}
          onClick={handleSubmit}
          sx={{ height: 48, width: "20%" }}>
          {loading ? <CircularProgress size={24} sx={{ color: selectedClientData?.AccentColor }} /> : TEXT_SUBMIT}
        </Button>
      </Box>
      <Snackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        autoHideDuration={3000}
      />
    </Box>
  );
};

export default AddEquipmentInspections;
